module.exports = __webpack_public_path__ + "static/media/check-green.1c1c927e.png";